import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import AngSelect from "Common/Angular/AngSelect";
import TaskInput from "TaskDialogCommon/TaskInput";
import { DialogButton } from "Common/DialogButton";

export const getHighestNumberInObject = (obj) => {
  for (var i = 1; i < 100; i++) {
    if (obj[i] === undefined) {
      return i;
    }
  }
};

export const TowerEventMapSelector = (props) => {
  const { label, taskConfig, param, setValue, selectedTowerData } = props;
  const [selectedevent, setselectedevent] = React.useState(null);
  const [selectedeventquantity, setselectedeventquantity] = React.useState(
    999999
  );

  if (!selectedTowerData || selectedTowerData.events.length === 0) {
    return null;
  }

  const valueobj = taskConfig[param];

  logger.log("props TowerEventMapSelector", props);

  const addEventToTowerPlayConfig = (selectedtroop, selectedquantity) => {
    if (!selectedtroop) {
      alert("Select an event type first.");
      return;
    }
    if (!selectedquantity) {
      alert("Set an event quantity.");
      return;
    }
    const troopobject = { ...valueobj };
    const highestNumberInObject = getHighestNumberInObject(troopobject);
    troopobject[highestNumberInObject] = {
      event: selectedevent,
      quantity: selectedeventquantity,
    };
    setValue(
      {
        target: {
          value: troopobject,
        },
      },
      param
    );
    setselectedevent(null);
    setselectedeventquantity(999999);
  };

  const clearSelection = () => {
    setValue(
      {
        target: {
          value: {},
        },
      },
      param
    );
  };

  return (
    <>
      <div style={{ float: "left" }}>{label}</div>
      <div
        style={getStyleJSON(
          "display:inline-flex;margin-top:10px;"
        )}
        className="fullWidth"
      >
        <div style={{ flex: "1", maxWidth: "70%" }}>
          <AngSelect
            ng-model={selectedevent}
            styleStr="margin: 0 auto;"
            options={
              selectedTowerData && selectedTowerData.events
                ? selectedTowerData.events.map((event) => {
                    return {
                      label: event.name,
                      value: event,
                    };
                  })
                : []
            }
            onChange={({ value }) => {
              setselectedevent(value);
            }}
          />
        </div>
        <div
          style={getStyleJSON(
            "margin-left: 10px; padding-right: 0px;display: flex;justify-content: center;align-items: center;"
          )}
        >
          <TaskInput
            placeholder="Quantity"
            value={selectedeventquantity}
            onChange={({ target: { value } }) => {
              setselectedeventquantity(value);
            }}
            type="number"
          />
        </div>
      </div>

      <div style={getStyleJSON("margin-top:10px;display: flex;")}>
        <DialogButton
          label="Add Event for Claim"
          style={getStyleJSON("font-weight: bold; font-size: 15px")}
          onClick={() => {
            addEventToTowerPlayConfig(selectedevent, selectedeventquantity);
          }}
        />
        <DialogButton
          label="Clear Events"
          style={getStyleJSON("font-weight: bold; font-size: 15px")}
          onClick={() => {
            clearSelection();
          }}
        />
      </div>

      {taskConfig[param] &&
        Object.keys(taskConfig[param]).map((key) => {
          const value = taskConfig[param][key];
          return (
            <div style={getStyleJSON("display:flex;margin-top:10px;")}>
              <div
                style={getStyleJSON(
                  "margin-left: 20px; padding-right: 0px; flex: 1;text-align: left;"
                )}
              >
                {key}.{value.event.name}
              </div>
              <div
                style={getStyleJSON("margin-left: 20px; margin-right: 20px;")}
              >
                {value.quantity}
              </div>
            </div>
          );
        })}
    </>
  );
};
